import { Container } from '@mui/material';
import ErrorScreen from '../../../../../components/Common/ErrorScreen';
import LoadingScreen from '../../../../../components/Common/LoadingScreen';
import useCalificarAtencion from '../hooks/useCalificarAtencion';
import CalificacionForm from './CalificacionForm';
import CalificacionResumen from './CalificacionResumen';
import { ESTADO_PAGINA } from '../constants/calificacionConstants';

const CalificarAtencion = () => {
  const { estado, turno, isSubmitting, submitError, enviarCalificacion, reintentar } =
    useCalificarAtencion();

  if (estado === ESTADO_PAGINA.CARGANDO) {
    return <LoadingScreen message="Buscando tu turno..." />;
  }

  if (estado === ESTADO_PAGINA.INVALIDO) {
    return (
      <ErrorScreen
        title="Enlace no disponible"
        error="Este enlace ya no es válido"
        subtitle="Puede haber expirado (los enlaces de calificación duran 72 horas) o ser incorrecto. No es posible generar un nuevo enlace desde esta página."
      />
    );
  }

  if (estado === ESTADO_PAGINA.ERROR) {
    return (
      <ErrorScreen
        title="No pudimos cargar tu turno"
        error="Ocurrió un error al buscar la información"
        subtitle="Verificá tu conexión e intentá nuevamente."
        onRetry={reintentar}
      />
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 3, sm: 5 } }}>
      {estado === ESTADO_PAGINA.CALIFICADO ? (
        <CalificacionResumen turno={turno} />
      ) : (
        <CalificacionForm
          turno={turno}
          isSubmitting={isSubmitting}
          submitError={submitError}
          onSubmit={enviarCalificacion}
        />
      )}
    </Container>
  );
};

export default CalificarAtencion;
